import moment from "moment";

const filterPeriodOptions = [
    {
        id: "last12Months",
        name: "Últimos 12 meses",
        start_date: moment()
            .subtract(11, "month")
            .startOf("month")
            .format("YYYY-MM-DD"),
        end_date: moment()
            .endOf("month")
            .format("YYYY-MM-DD"),
    },
    {
        id: "currentYear",
        name: "Año en curso",
        start_date: moment()
            .startOf("year")
            .format("YYYY-MM-DD"),
        end_date: moment()
            .endOf("month")
            .format("YYYY-MM-DD"),
    },
    {
        id: "lastYear",
        name: "Año anterior",
        start_date: moment()
            .startOf("year")
            .subtract(1, "year")
            .format("YYYY-MM-DD"),
        end_date: moment()
            .endOf("year")
            .subtract(1, "year")
            .format("YYYY-MM-DD"),
    },
    {
        id: "currentMonth",
        name: "Mes en curso",
        start_date: moment()
            .startOf("month")
            .format("YYYY-MM-DD"),
        end_date: moment()
            .endOf("month")
            .format("YYYY-MM-DD"),
    },
];

const monthsNames = [
    "Enero",
    "Febrero",
    "Marzo",
    "Abril",
    "Mayo",
    "Junio",
    "Julio",
    "Agosto",
    "Septiembre",
    "Octubre",
    "Noviembre",
    "Diciembre",
];

export { filterPeriodOptions, monthsNames };
